import { cn } from "@ui/lib/utils";

import type { VoiceWithPreview } from "./types";
import { VoiceAvatar } from "./VoiceAvatar";

interface VoiceChipProps {
  voice: VoiceWithPreview;
  index: number;
  className?: string;
}

export function VoiceChip({ voice, index, className }: VoiceChipProps) {
  const firstName = voice.name.split(" ")[0];

  return (
    <div
      className={cn(
        "tw-inline-flex tw-items-center tw-gap-2 tw-px-3 tw-py-1 tw-rounded-full tw-h-10 bg-default",
        className,
      )}
      style={{
        boxShadow: "0 0 0 1px rgba(0,0,0,0.06), 0 1px 2px 0 rgba(0,0,0,0.04), 0 2px 4px 0 rgba(0,0,0,0.04)",
      }}
    >
      <VoiceAvatar index={index} className='tw-size-6 tw-shrink-0 tw-rounded-full' width={24} height={24} />
      <span className='tw-truncate f-paragraph-03'>{firstName}</span>
    </div>
  );
}
